export default {
  overrideRequest: function (axiosConfig) {},
  logger: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/Utility.js